import script from "./HiddenMasterProductByCompanyDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./HiddenMasterProductByCompanyDetail.vue?vue&type=script&setup=true&lang=ts"

import "./HiddenMasterProductByCompanyDetail.vue?vue&type=style&index=0&id=bfe94350&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfe94350"]])

export default __exports__